// remove sticky class when reaching offsetY = 0
function handleSearchSticky() {
  const searchBarElm = document.querySelector(".storepoint-search-bar");
  if (!searchBarElm) return;
  if (window.scrollY > 154) {
    searchBarElm.parentElement.classList.add("d-fixed");
    searchBarElm.closest(".storepoint-container").classList.add("on-fixed");
  } else {
    searchBarElm.parentElement.classList.remove("d-fixed");
    searchBarElm.closest(".storepoint-container").classList.remove("on-fixed");
  }
}

// hide the search bar when seeing .shopify-section-footer
function handleFooterOverlap() {
  const searchBarElm = document.querySelector(".storepoint-search-bar");
  const filterDropdownElm = document.querySelector(".storepoint-filter-dropdown");
  const footerElm = document.querySelector("#shopify-section-footer");
  if (!searchBarElm || !footerElm) return;
  // Use Intersection Observer to hide search bar when footer is visible
  if (!window.footerObserverInitialized) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            searchBarElm.classList.add("hidden");
            filterDropdownElm.classList.add("hidden");
          } else {
            searchBarElm.classList.remove("hidden");
            filterDropdownElm.classList.remove("hidden");
          }
        });
      },
      {
        root: null,
        threshold: 0.5,
      },
    );
    observer.observe(footerElm);
    window.footerObserverInitialized = true;
  }
}
window.addEventListener("scroll", () => {
  if (window.innerWidth <= 768) {
    handleSearchSticky();
    handleFooterOverlap();
  }
});
